import styled from 'styled-components';

import { media } from '@prisjakt/ui-base';

export const Text = styled.div`
  max-width: 66%;

  ${media.smallOnly`
    max-width: 100%;
  `};
`;
